import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import { useEffect, useState } from "react";
import { addViewportIsMobileListener, dnbComLog, isNotUndefined, LogSeverity } from "../FunctionsCore";
import { classCombinerFromPrefix, renderIdentifierGeneric } from "../RenderIdentifier";
import GalleryPaginationStyles from "./GalleryPaginationStyles.module.scss";
const styles = GalleryPaginationStyles;
const classCombiner = classCombinerFromPrefix("6057ced3e08b8976");
const galleryPaginationWrapper = {
    "addGalleryPaginationCallback": (ga) => {
        const { galleryPaginationFunctions, queuedGalleryPaginationCallbacks } = galleryPaginationWrapper;
        if (isNotUndefined(galleryPaginationFunctions)) {
            ga(galleryPaginationFunctions);
        }
        else {
            queuedGalleryPaginationCallbacks.push(ga);
        }
    },
    "galleryPaginationFunctions": void 0,
    "queuedGalleryPaginationCallbacks": [],
    "runGalleryPaginationCallbacks": (ga) => {
        galleryPaginationWrapper.galleryPaginationFunctions = ga;
        const { queuedGalleryPaginationCallbacks } = galleryPaginationWrapper;
        for (const queuedMarketoFormLoadCallback of queuedGalleryPaginationCallbacks) {
            try {
                queuedMarketoFormLoadCallback(ga);
            }
            catch (er) {
                dnbComLog(LogSeverity.ERROR, er);
            }
        }
        galleryPaginationWrapper.queuedGalleryPaginationCallbacks = [];
    },
};
const resultsPerPage = 6;
// TODO
// From Bootstrap
const hideClassName = "hide";
const getChildren = () => $(".galleryList .thumb-scroll .thumb-scroll-content").children();
const GalleryPaginationComponent = (props) => {
    const { labelOfText, labelPageText } = props;
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [resultsReturned, setResultsReturned] = useState(0);
    const [inputValue, setInputValue] = useState(window.String(currentPageNumber));
    const numberOfPages = window.Math.ceil(resultsReturned / resultsPerPage);
    const tryToChangePageNumber = (desiredPageNumber) => {
        if (desiredPageNumber > numberOfPages) {
            return numberOfPages;
        }
        if (desiredPageNumber < 1) {
            return 1;
        }
        return desiredPageNumber;
    };
    const renderCurrentPage = () => {
        const $children = getChildren();
        $children.addClass(hideClassName);
        const start = (currentPageNumber - 1) * resultsPerPage;
        const end = currentPageNumber * resultsPerPage;
        for (let i = start; i < end; i += 1) {
            $children
                .eq(i)
                .removeClass(hideClassName);
        }
    };
    const incrementOrDecrementPageNumber = (trueIfIncrementFalseIfDecrement) => {
        const delta = trueIfIncrementFalseIfDecrement ? 1 : -1;
        return setCurrentPageNumber((nu) => {
            const newPageNumber = tryToChangePageNumber(nu + delta);
            setInputValue(window.String(newPageNumber));
            return newPageNumber;
        });
    };
    // TODO Hack
    useEffect(() => {
        renderCurrentPage();
        $(renderCurrentPage);
        addViewportIsMobileListener(renderCurrentPage);
    }, []);
    // TODO Hacky
    useEffect(() => {
        galleryPaginationWrapper.runGalleryPaginationCallbacks({
            // TODO galleryPageRange is never updated
            "getGalleryPageRange": () => resultsPerPage,
            "getResultsReturned": () => resultsReturned,
            "updateResultsReturned": () => {
                const childrenLength = getChildren().length;
                setResultsReturned(childrenLength);
                return childrenLength;
            }
        });
    }, [resultsReturned]);
    // TODO Mutation
    useEffect(renderCurrentPage, [currentPageNumber]);
    return _jsx("div", Object.assign({ className: cx(classCombiner(styles, "galleryContainer")) }, { children: _jsx("div", Object.assign({ className: cx("row") }, { children: _jsxs("div", Object.assign({ className: cx("col-md-12") }, { children: [_jsx("div", Object.assign({ className: cx(classCombiner(styles, "inlineBlockDiv")) }, { children: labelPageText })), _jsx("div", Object.assign({ className: cx(classCombiner(styles, "inlineBlockDiv")) }, { children: _jsx("input", { className: cx(classCombiner(styles, "galleryPaginationPageInput")), onBlur: () => setInputValue(window.String(currentPageNumber)), onChange: (ke) => {
                                const value = ke.target.value;
                                const valueInt = window.Number.parseInt(value);
                                if (window.Number.isNaN(valueInt)) {
                                    const valueOnlyDigits = value.replace(/\D/g, "");
                                    setInputValue(valueOnlyDigits);
                                }
                                else {
                                    const newPageNumber = tryToChangePageNumber(valueInt);
                                    setInputValue(window.String(newPageNumber));
                                    setCurrentPageNumber(newPageNumber);
                                }
                            }, type: "text", value: inputValue }) })), _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "inlineBlockDiv")) }, { children: [labelOfText, " ", numberOfPages] })), _jsxs("div", Object.assign({ className: cx(classCombiner(styles, "previousNextWrapper"), classCombiner(styles, "inlineBlockDiv")) }, { children: [_jsx("div", Object.assign({ className: cx(classCombiner(styles, "previous")) }, { children: _jsx("button", { "aria-label": "Go to previous page", className: cx(classCombiner(styles, "previousButton")), onClick: () => incrementOrDecrementPageNumber(false), type: "button" }) })), _jsx("div", Object.assign({ className: cx(classCombiner(styles, "next")) }, { children: _jsx("button", { "aria-label": "Go to next page", className: cx(classCombiner(styles, "nextButton")), onClick: () => incrementOrDecrementPageNumber(true), type: "button" }) }))] }))] })) })) }));
};
const galleryPagination = (renderableData) => renderIdentifierGeneric(GalleryPaginationComponent, renderableData);
export { galleryPagination, galleryPaginationWrapper, getChildren, hideClassName };
